import React from 'react';
import BaseDialog, { } from './BaseDialog';
import { DialogContentText } from '@material-ui/core';













export default function ConfirmDialog({
  btnCloseText = 'Cancel',
  btnSubmitDisabled,
  btnSubmitText = 'Confirm',
  contentText = 'Are you sure you want to perform this action ?',
  handleClose,
  handleSubmit,
  isOpen,
  isSending,
  title = 'Confirm Action',
}) {
  return (
    React.createElement(BaseDialog, {
      isOpen: isOpen,
      title: title,
      handleClose: handleClose,
      handleSubmit: handleSubmit,
      btnSubmitText: btnSubmitText,
      btnCloseText: btnCloseText,
      btnSubmitDisabled: btnSubmitDisabled,
      isSending: isSending,}
    
      , React.createElement(DialogContentText, null, contentText)
    )
  );
}
